var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Grid } from "syf-component-library/ui/patterns";
import { Inline, Stack } from "syf-component-library/ui/spacing";
import { Body } from "syf-component-library/ui/typography";
import { ColoredSideTab, CreditInfluencesTitle, CreditInfluencesWrapper, InfluenceTypeText, InfluencesGridWrapper, } from "./subcomponents";
import VantageTrans from "../../../atoms/VantageTrans";
var CreditInfluences = function () {
    var t = useTranslation().t;
    var influenceData = t("creditScorePage.influences", {
        returnObjects: true,
    });
    return (_jsxs(CreditInfluencesWrapper, { children: [_jsx(CreditInfluencesTitle, __assign({ as: "h2", weight: "bold" }, { children: _jsx(VantageTrans, { i18nKey: "creditScorePage.headers.influences" }) })), _jsx(Stack, { size: "xlarge" }), influenceData.map(function (data) {
                return (_jsxs("div", { children: [_jsxs(InfluencesGridWrapper, { children: [_jsx(ColoredSideTab, { color: data.color }), _jsx(Inline, { size: "large" }), _jsxs(Grid, __assign({ direction: "column" }, { children: [_jsxs(Grid, __assign({ direction: "row" }, { children: [_jsxs(Body, __assign({ weight: "bold" }, { children: [data.header, " -"] })), _jsx(InfluenceTypeText, __assign({ color: data.color }, { children: data.influenceType }))] })), _jsx(Body, { children: data.body })] }))] }), _jsx(Stack, { size: "medium" })] }, "tip-card-".concat(data.header)));
            }), _jsx(Stack, { size: "large" })] }));
};
export default CreditInfluences;
